import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import TextRenderer from '../../../TextRenderer';
import CommentViewer from '../../../DaEditorWrapper/Viewer/Comment';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import CommentFooter from '../CommentFooter';
import { CommentContext } from '../CommentContext';
import ActionsMenu from '../ActionsMenu';
import SpamCommentBody from '../SpamCommentBody';
import HiddenCommentBody from '../HiddenCommentBody';
import EditingCommentContent from './EditingCommentContent';
import { isActionable } from '../../utils';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CommentTimestamp from '../CommentTimestamp';
import s from './CommentContent.scss';
var CommentContent = function (_a) {
    var currentUser = _a.currentUser, className = _a.className, canPostComment = _a.canPostComment, onReplyPosted = _a.onReplyPosted, replyClassName = _a.replyClassName, actionItemClassName = _a.actionItemClassName, onCommentUpdated = _a.onCommentUpdated, 
    // TODO: originally meant to flash the bg green,
    // product may want this restored at some point
    // highlightOnMount,
    orphanPlaceholder = _a.orphanPlaceholder, nc = _a.nc, _b = _a.includeFooter, includeFooter = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _c = useContext(CommentContext), comment = _c.comment, isEditing = _c.isEditing, isPeeking = _c.isPeeking, setCanShowActionMenu = _c.setCanShowActionMenu;
    var isSpam = comment.isSpam, isHidden = comment.isHidden, isDeleted = comment.isDeleted, isAdminHidden = comment.isAdminHidden, isFeatured = comment.isFeatured, replies = comment.replies, user = comment.user, textContent = comment.textContent, commentId = comment.commentId;
    var isVisible = !isAdminHidden && !isDeleted;
    if (isEditing) {
        return (React.createElement(EditingCommentContent, { currentUser: currentUser, canPostComment: canPostComment, className: className, onCommentUpdated: onCommentUpdated }));
    }
    if (!isPeeking && isSpam && replies !== 0) {
        return React.createElement(SpamCommentBody, null);
    }
    if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
        return React.createElement(HiddenCommentBody, { className: className });
    }
    if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return React.createElement(React.Fragment, null, orphanPlaceholder);
    }
    var placeAvatarInside = false;
    var featured = isFeatured ? (React.createElement("span", { className: s['featured'] }, t('comment.visibility.featuredV2'))) : null;
    return (React.createElement("div", { className: classnames(s['comment-content'], s['core-badges'], className), "data-commentid": comment.commentId, "data-typeid": comment.typeId, "data-itemid": comment.itemId },
        user && !placeAvatarInside && (React.createElement(UserAvatar, { user: user, size: isMobile ? 24 : 32, className: s['avatar'], withTooltip: false })),
        React.createElement("div", { className: s['main-block'] },
            React.createElement("div", { className: classnames(s['body-block'], isFeatured && s['body-block-featured'], isActionable(comment) && s['is-actionable']), onMouseEnter: function () { return setCanShowActionMenu(true); }, onMouseLeave: function () { return setCanShowActionMenu(false); } },
                React.createElement(Flex, { alignItems: placeAvatarInside ? 'center' : 'baseline', className: s['author-block'] },
                    user && placeAvatarInside && (React.createElement(UserAvatar, { user: user, size: 24, className: s['avatar'], withTooltip: false })),
                    user && (React.createElement(UserLink, { user: user, className: classnames(s['userlink'], comment.isAuthorHighlited && s['userlink-author']), withTooltip: true, relatedItemBiData: {
                            typeid: comment.typeId,
                            itemid: comment.itemId,
                        } })),
                    React.createElement(CommentTimestamp, { className: s['timestamp'] }),
                    featured),
                !!textContent && (React.createElement("div", { "data-hook": BiDataHook.COMMENT_BODY },
                    React.createElement(TextRenderer, { className: s['renderer'], textContent: textContent, reactViewer: CommentViewer, legacyTheme: 'comments', viewerKey: commentId }))),
                React.createElement(ActionsMenu, { className: s['actions-menu'], itemClassName: actionItemClassName })),
            includeFooter && (React.createElement(CommentFooter, { nc: nc, onReplyPosted: onReplyPosted, canPostComment: canPostComment, replyClassName: replyClassName })))));
};
export default CommentContent;
//# sourceMappingURL=CommentContent.js.map